import React from "react";
import { useState, useEffect } from "react";

const ScrollToTopButton = () => {
  const [isVasible, setIsVasible] = useState(false);

  const toggleVisibilty = () => {
    if (window.pageYOffset > 300) {
      setIsVasible(true);
    } else {
      setIsVasible(false);
    }
  };

  const scrollToTop = () => {
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
  };

  useEffect(() => {
    window.addEventListener("scroll", toggleVisibilty);
    return () => {
      window.removeEventListener("scroll", toggleVisibilty);
    };
  }, []);

  return (
    <div
      id="to-top-btn"
      onClick={scrollToTop}
      className={isVasible ? "show" : ""}
    ></div>
  );
};

export default ScrollToTopButton;
